import { render } from "./version-update.vue?vue&type=template&id=c9329ed0&scoped=true&ts=true"
import script from "./version-update.vue?vue&type=script&lang=ts"
export * from "./version-update.vue?vue&type=script&lang=ts"

import "./version-update.vue?vue&type=style&index=0&id=c9329ed0&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9329ed0"]])

export default __exports__